// extracted by mini-css-extract-plugin
module.exports = {"facebookButton":"FacebookAuth_facebookButton__PnO3h","facebookButtonText":"FacebookAuth_facebookButtonText__3KsEB"};